exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-size[data-v-dd4a0c14] {\n    font-size: x-large;\n}\n.background-grey[data-v-dd4a0c14] {\n    background: #f8f8f8;\n}\n.social-icons-bg[data-v-dd4a0c14] {\n    height: 40px;\n    width: 40px;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1em;\n    margin: 1em;\n    cursor: pointer;\n}\n.rotating-icon[data-v-dd4a0c14] {\n    animation: spin 2s linear infinite;\n}\n", ""]);

// exports
